import { render } from "./importForms.vue?vue&type=template&id=f449c050&scoped=true"
import script from "./importForms.vue?vue&type=script&lang=js"
export * from "./importForms.vue?vue&type=script&lang=js"

import "./importForms.vue?vue&type=style&index=0&id=f449c050&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f449c050"]])

export default __exports__